import React from 'react';
import {
  SFStateMandatedLabel,
  useStateMandatedStyles
} from './SFSateMandatedLabel';
import { InputLabelProps } from '@material-ui/core';

export const getInputLabel = (
  stateMandated: boolean,
  label: React.ReactNode | string | undefined,
  required: boolean | undefined,
  missingInformation?: boolean
): React.ReactNode | string | undefined => {
  return stateMandated ? (
    <SFStateMandatedLabel
      label={label}
      required={required}
      missingInformation={missingInformation}
    />
  ) : (
    `${label || ''}`
  );
};

export const getInputLabelProps = (
  stateMandated: boolean
): Partial<InputLabelProps> | undefined => {
  const classes = useStateMandatedStyles();

  return stateMandated
    ? {
        classes: {
          asterisk: classes.asterisk // Apply override locally
        }
      }
    : undefined;
};
